import { authBlobFetcher } from 'packages/lib/utils/fetch';
import { AnyObject } from 'packages/lib/common-types/types';
import {
  patch,
  post,
  remove,
} from 'packages/lib/utils/legacy-tsapi/rest-helpers';
import { NullableString } from 'packages/lib/common-types/types';
import {
  AnnotationType,
  PolygonType,
} from 'packages/lib/api/annotations/contract/enums';
interface PatchArray {
  op: 'replace';
  path: string;
  value: AnyObject;
}

export function preparePatchArray<T extends AnyObject>(obj: T): PatchArray[] {
  const fields = Object.keys(obj);
  return fields.map((f) => ({
    op: 'replace',
    path: f,
    value: obj[f],
  }));
}

/** @returns Promise containing true for success, false for failure. */
export const patchImageAnnotation = async (
  annotationToken: string,
  patchData: AnyObject
): Promise<boolean> => {
  const [, resp] = await patch(
    'annotations',
    `/image-annotations/${annotationToken}`,
    patchData
  );
  return resp.status === 200;
};

/** @returns Promise containing true for success, false for failure. */
export const patchPolygonInstance = async (
  annotationToken: string,
  patchData: AnyObject
): Promise<boolean> => {
  const [, resp] = await patch(
    'annotations',
    `/image-instance-segments/${annotationToken}`,
    patchData
  );
  return resp.status === 200;
};

export const saveNewAnnotation = async (annotation: {
  imageDataToken?: NullableString;
  type?: AnnotationType | PolygonType;
}): Promise<string> => {
  const [{ token }] = await post(
    'annotations',
    annotation.type === 'Instance'
      ? '/image-instance-segments'
      : '/image-annotations',
    annotation
  );
  return token;
};

export const removeAnnotation = async (
  token: string,
  type = 'BoundingBox'
): Promise<ReturnType<typeof remove>> =>
  remove(
    'annotations',
    `/${
      type === 'Instance' ? 'image-instance-segments' : 'image-annotations'
    }/${token}`
  );

export const fetchPdfContent = async (
  attachmentToken: string
): Promise<Blob> => {
  return authBlobFetcher(`/attachments/${attachmentToken}/content`, {
    baseURL: 'annotations',
    headers: {
      Accept: 'application/pdf',
    },
  });
};
